import React from 'react';
import { PictoProps } from './index';

export const Clock = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '23'}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.7251"
      cy="11.3053"
      r="10"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7251 5.3053V11.3053L15.7251 13.3053"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
